import type { IconData } from '@stacksjs/iconify-core'

export const devicesKeyboard: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 2H0v12h16zM5 5H3v2h2zm2 0h2v2H7zM5 9h6v2H5zm6-4h2v2h-2z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesKeyboard
